import { Action } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'

import { AppDispatch, apphistory, AppState, store } from '..'
import { SessionStorage } from '../../common/cookie-storage'
import { ApiError, HttpClient, StartLinkVisitParams } from '../../common/http-client'
import { HUB_CONNECTION_STATUS, HubClient } from '../../common/hub-client'
import { STORAGEKEYS } from '../../common/keys'
import { Environment } from '../../environment/app-settings'
import { IBankVerifyHub, IDocumentsRedyHub, IRejectedHub, IClientChoiceIdentification, IContractDone, IValidationFailedWaitForContact, IValidationManualWaitForContact, IWaitForValidationCompletion, IMobProcessing, ConnectionState, IPreparedForDisbursed } from '../../models/credential-actions-models'
import { OffertCamelCase } from '../../models/responses/auth-succesfull.response'
import { BMGateVerificationUrl } from '../../models/responses/bm-verify-url.response'
import { BlueMediaService } from '../../service/bm-service'
import settingsService from '../../service/settings-service'
import {
  APP_READY,
  BANK_VERIFICATION,
  CHANGE_APPLICATION_STATE,
  CLEAR,
  GET_BM_BANKS,
  HUB_CONNECTED,
  HUB_DISCONNECTED,
  PREPARE_APP_REQUEST,
  RETURN_FROM_BM,
  SET_APP_HAS_ERROR,
  SET_CONTRACT_DONE_DATA,
  SET_CURRENT_SELECTED_PREDEFINED_PERIOD,
  SET_HUB_CONNECTION_STATUS,
  SET_IS_PREDEFINED_PERIODS_AVAILABLE,
  SET_MANUAL_VERIFICATION_HUB_VERIFICATION_STATE,
} from '../actions/application-actions'
import { CONSENT_FETCHED } from '../actions/consent-action'
import { CHANGE_CURRENT_INSTALLMENT_NUMBER, SET_INITIAL_OFFER, SET_MAX_LOAN_AMOUNT_FOR_MIN_INSTALLMENT, SET_PREDEFINED_USER_OFFERS_ARRAY, SET_PREDEFINED_USER_OFFERS_OBJECT } from '../actions/offert-action'
import { APP_SOURCE_TYPES, IGetCredentialsResponse, IOfferState, IPredefinedSingleOfferResponse, IRecalculateOffertHubData, PREDEFINED_OFFERS_FETCH_TYPE, PREDEFINED_PERIODS_OFFER_LOGIC, PredefinedOfferNames, PredefinedUserOfferObject } from '../types'
import { AppLinks } from '../../environment/app-links'
import { youMoneyService, youAffService, finperialService, eHelikonService } from '../../service/PartnersServices'
import { Guid } from '../../common/helpers/guid'
import { SET_AGREEMENT_FILE_NAME } from '../actions/code-actions'
import applicationService from '../../service/application.service'
import analyticsService from '../../service/analytics.service'
import { selectCustomClientOfferBasedOnLoanLimits } from '../../pages/CustomClientOfferPage/customClientOffersConfig'
import offerService, { GetPredefinedOfferCustomErrorFromBackend, PREDEFINED_OFFERS_CUSTOM_ERROR_CODES } from '../../service/OfferService'
import { getMinimumLoanAmount } from '../../common/helpers/helpers'
import { ApplicationStates } from '../../components/organisms/Sidebar/pageStepperData'
import { isEmpty } from 'lodash'


const _clearMObywatelCache = (sessionStorage: SessionStorage) => {
  sessionStorage.changeItemValue(STORAGEKEYS.CURRENT_MOBYWATEL_CODE, "")
  sessionStorage.changeItemValue(STORAGEKEYS.MOBYWATEL_IS_AFTER_FIRST_RENDER, "false")
  sessionStorage.remove(STORAGEKEYS.MOBYWATEL_IS_FIRST_RENDER)
  sessionStorage.remove(STORAGEKEYS.MOBYWATEL_CODE_EXPIRED_TIME)
}


export const getCredentials = (orderId: string, startLinkVisit?: StartLinkVisitParams): ThunkAction<Promise<IGetCredentialsResponse>, AppState, unknown, Action<any>> => async(dispatch) => {
  try {
    dispatch({ type: CLEAR })
    const client = new HttpClient(Environment.apiUrl)
    const response = (await client.authRequest(orderId, startLinkVisit)).data


    if (response) {
      const sessionStorage = new SessionStorage();
      sessionStorage.add(STORAGEKEYS.ACCESS_TOKEN, response.access_token)
      sessionStorage.add(STORAGEKEYS.USER_SESSION, "true")
      sessionStorage.add(STORAGEKEYS.CURRENT_WORKFLOW_ID, response.workflowId.toString()) // ZAPISUJEMY WORKFLOW ID W SESSION STARAGE, ABY MIEĆ DO NIEGO DOSTĘP W CAŁEJ APLIKACJI
      sessionStorage.addCookie( STORAGEKEYS.SESSION_ID, Guid())
  
      const consents = await settingsService.getConsents()
      await analyticsService.sendBrowserData()
      
      dispatch({
        type: CONSENT_FETCHED,
        payload: consents,
      })

      const offert = OffertCamelCase(response.offert)

      dispatch({
        type: APP_READY,
        payload: {
          offert: offert,
          billingCompany: response.biillingCompany,
          appId: orderId,
          amountToPay: response.requestedAmount,
          successReturnUrl: response.successReturnUrl,
          failureReturnUrl: response.failureReturnUrl, //TODO:mj: dodac propagacje tez danych do werfikacji w banku oraz tez ostatni ustawiony status
          applicationStatus: response.currentStatus,
          workflowId: response.workflowId,
          affiliatePartnerId: response.affiliatePartnerId,
        },
      })

      return {
        workflowId: response.workflowId,
        userEmail: response.email,
        currentRequestedAmount: response.requestedAmount,
        currentInstalments: response.installments,
        currentInstalmentAmount: response.instalmentAmount,
        affiliatePartnerId: response.affiliatePartnerId,
      }
    }
    else {
      throw new ApiError("Nie udało się pobrać konfiguracji tokena. Otrzymano pustą odpowiedź z serwera.", 500)
    }
  }
  catch (error) {
    throw error
  }
}

export const recreateCredentials = (uuid: string): ThunkAction<void, AppState, unknown, Action<any>> => async(dispatch) => {
  try {
    dispatch({ type: PREPARE_APP_REQUEST })

    const client = new HttpClient(Environment.apiUrl)
    const response = (await client.authRequestByUuid(uuid)).data


    if (response) {
      const sessionStorage = new SessionStorage()
      sessionStorage.add(STORAGEKEYS.ACCESS_TOKEN, response.access_token)
      sessionStorage.add(STORAGEKEYS.USER_SESSION, "true")
      sessionStorage.addCookie(STORAGEKEYS.SESSION_ID, Guid())


      const service = new BlueMediaService()

        service.getBanks().then(async (p) => {
          await dispatch({
            type: GET_BM_BANKS,
            payload: p,
          })
        })

        dispatch({ type: RETURN_FROM_BM })

        dispatch({
          type: APP_READY,
          payload: {
            offert: response.offert,
            billingCompany: response.billingCompany,
            appId: uuid,
            amountToPay: response.offert?.loanAmountNet ?? 0,
            successReturnUrl: response.successReturnUrl,
            failureReturnUrl: response.failureReturnUrl,
            workflowId: response.workflowId,
          },
        })
      }
  }
  catch (error) {
    throw new Error("Nie udało się odtworzyć konfiguracji tokena, po powrocie do aplikacji. " + (error as Error).message)
  }
}

export const subscribeToHub = (hub: HubClient, dispatch: ThunkDispatch<AppState, unknown, Action<any>>, source?: APP_SOURCE_TYPES) => {
  const hubMethods = HubClient.hubMethods
  const sessionStorage = new SessionStorage()

    //#region ========================================= FUNKCJE POMOCNICZE =========================================

    const getAnalyticsEventTypesNames = () => store.getState().lenConfigState.analyticsEventTypesNames
  
    const checkIsPredefinedOffersArrayValid = (offersArray: IPredefinedSingleOfferResponse[]) => {
      return Boolean(offersArray !== null && offersArray !== undefined && offersArray.length > 0)
    }

    const _savePredefinedOffersForDefaultFlow = async (predefinedOffers: IPredefinedSingleOfferResponse[], calculateOfferData: IOfferState) => {
      if(checkIsPredefinedOffersArrayValid(predefinedOffers) === false) {
        throw new Error("Nie udało się pobrać predefiniowanych ofert z backendu, lub otrzymana tablica była pusta")
      }

      const additionalPredefinedOfferPageDisplayedData = {
        source: source ?? "",
        isPredefinedPeriodsLogicAvailable: false,
        userRequestedAmount: calculateOfferData.requestedAmount,
        predefinedUserOffersArray: predefinedOffers,
        customUserOfferLimits: {
          description: "Szczegóły oferty z kalulatora",
          offerId: calculateOfferData.offerId,
          minimumLoanAmount: calculateOfferData.minimumLoanAmount,
          maximumLoanAmount: calculateOfferData.currentMaximumLoanAmount,
          instalments: calculateOfferData.currentSelectedInstallmentNumber
        },
        recommendedOffer: {
          description: "Szczegóły oferty rekomendowanej",
          ...predefinedOffers.find(singleOffer => singleOffer.isRecommended === true)
        },
      }

      await analyticsService.createSingleAnalyticEvent(getAnalyticsEventTypesNames()?.PredefinedOfferPageDisplayed, JSON.stringify(additionalPredefinedOfferPageDisplayedData, undefined, 3))

      dispatch({
        type: SET_PREDEFINED_USER_OFFERS_OBJECT,
        payload: undefined
      })

      dispatch({
        type: SET_PREDEFINED_USER_OFFERS_ARRAY,
        payload: predefinedOffers
      })
    }


    const _fetchPredefinedOffersForDefaultFlow = async (calculateOfferData: IOfferState) => {
      // W domyślnym przypadku, pobieramy raz tablicę z predefiniowanymi ofertami, dla obecnie wybranej liczby rat (W TYM, DOMYŚLNYM PRZYPADKU BĘDZIE TO NAJWIĘKSZA DOSTĘPNA DLA UŻYTKOWNIKA LICZBA RAT)
      const predefinedOffersFromBackend = await offerService.getPredefinedOffer({ installmentNumber: calculateOfferData.currentSelectedInstallmentNumber })

      await _savePredefinedOffersForDefaultFlow(predefinedOffersFromBackend, calculateOfferData)
    }

    const fetchAndSavePredefinedOffers = async (type: PREDEFINED_OFFERS_FETCH_TYPE, calculateOfferData: IOfferState) => {
      try {
        if(type === PREDEFINED_OFFERS_FETCH_TYPE.DEFAULT) {
          await _fetchPredefinedOffersForDefaultFlow(calculateOfferData)
        }
        else if(type === PREDEFINED_OFFERS_FETCH_TYPE.PREDEFINED_PERIODS) {
          const shortPeriod = Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP[PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD]
          const longPeriod = Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP[PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD]

          try {
            const [shortPeriodResult, longPeriodResult] = await Promise.allSettled([
              offerService.getPredefinedOffer({
                installmentNumber: shortPeriod,
                isPredefinedPeriodsAvailable: true,
                predefinedPeriod: PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD
              }),
              offerService.getPredefinedOffer({
                installmentNumber: longPeriod,
                isPredefinedPeriodsAvailable: true,
                predefinedPeriod: PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD
              })
            ])

            if (shortPeriodResult.status === 'rejected' && longPeriodResult.status === 'rejected') {
              // Brak obu ofert: kalkulator korzysta z limitów otrzymanych z HUBa.
              dispatch({
                type: SET_INITIAL_OFFER,
                payload: {
                  ...calculateOfferData,
                  currentSelectedInstallmentNumber: calculateOfferData.maxInstallmentNumber,
                  isCustomOfferOnly: true,
                }
              })
              dispatch({ type: SET_CURRENT_SELECTED_PREDEFINED_PERIOD, payload: undefined })
              dispatch({ type: SET_IS_PREDEFINED_PERIODS_AVAILABLE, payload: false })
              return
            }

            // =================================== OBSŁUGA BŁĘDU PRZY PRZELICZENIU OFERTY DLA KRÓTKIEGO OKRESU SPŁATY ===================================

            if(shortPeriodResult.status === 'rejected') {
              const error = shortPeriodResult.reason

              if(
                error?.data?.errorCode === PREDEFINED_OFFERS_CUSTOM_ERROR_CODES.SHORT_PERIOD_OFFER_CALCULATION_FAILED
                && longPeriodResult.status === 'fulfilled'
                && checkIsPredefinedOffersArrayValid(longPeriodResult.value)
              ) {
                const longPeriodHighestOffer = longPeriodResult.value.find(offer => offer.name === PredefinedOfferNames.HIGHEST_OFFER)

                if(longPeriodHighestOffer === undefined) {
                  throw new Error("Nie udało się przygotować standardowego widoku oferty: brak oferty HIGHEST_OFFER dla długiego okresu.")
                }

                const fallbackOffers = [{ ...longPeriodHighestOffer, isRecommended: true }]
                const fallbackOfferData = { ...calculateOfferData, currentSelectedInstallmentNumber: longPeriod }

                dispatch({
                  type: CHANGE_CURRENT_INSTALLMENT_NUMBER,
                  payload: longPeriod
                })
                dispatch({
                  type: SET_CURRENT_SELECTED_PREDEFINED_PERIOD,
                  payload: undefined
                })
                dispatch({
                  type: SET_IS_PREDEFINED_PERIODS_AVAILABLE,
                  payload: false
                })
                await _savePredefinedOffersForDefaultFlow(fallbackOffers, fallbackOfferData)
                return
              }

              throw error
            }

            if(longPeriodResult.status === 'rejected') {
              throw longPeriodResult.reason
            }

            const shortPeriodOffersResponse = shortPeriodResult.value
            const longPeriodOffersResponse = longPeriodResult.value
            // =============================================================================================//

            const areShortPeriodOffersValid = checkIsPredefinedOffersArrayValid(shortPeriodOffersResponse)
            const areLongPeriodOffersValid = checkIsPredefinedOffersArrayValid(longPeriodOffersResponse)

            if (areShortPeriodOffersValid === false || areLongPeriodOffersValid === false) {
              throw new Error("Nie udało się pobrać predefiniowanych ofert z backendu, dla mechanizmu predefiniowanego okresu lub otrzymana tablica była pusta.")  // Przechwytujemy w catch w metodzie HUBA i ustawiamy globalny błąd
            }
            else {
              const additionalPredefinedOfferPageDisplayedData = {
                source: source ?? "",
                isPredefinedPeriodsLogicAvailable: true,
                userRequestedAmount: calculateOfferData.requestedAmount,
                predefinedUserOffersArray: [...longPeriodOffersResponse, ...shortPeriodOffersResponse],
                customUserOfferLimits: {
                  description: "Szczegóły oferty z kalulatora",
                  offerId: calculateOfferData.offerId,
                  minimumLoanAmount: calculateOfferData.minimumLoanAmount,
                  maximumLoanAmount: calculateOfferData.currentMaximumLoanAmount,
                  instalments: calculateOfferData.currentSelectedInstallmentNumber
                },
                recommendedOffer: {
                  description: "Mechanizm predefiniowanych okresów spłaty, nie posiada rekomendowanych ofert"
                },
              }

              await analyticsService.createSingleAnalyticEvent(getAnalyticsEventTypesNames()?.PredefinedOfferPageDisplayed, JSON.stringify(additionalPredefinedOfferPageDisplayedData, undefined, 3))
            
              const predefinedUserOffersObject: PredefinedUserOfferObject = {
                [PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD]: longPeriodOffersResponse,
                [PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD]: shortPeriodOffersResponse
              }
              const shortPeriodHighestOffer = shortPeriodOffersResponse.find(offer => offer.name === PredefinedOfferNames.HIGHEST_OFFER)

              if (shortPeriodHighestOffer === undefined) {
                throw new Error("Nie udało się ustalić maksymalnej kwoty dla krótkiego okresu: brak oferty HIGHEST_OFFER.")
              }

              dispatch({
                type: SET_PREDEFINED_USER_OFFERS_OBJECT,
                payload: predefinedUserOffersObject
              })

              dispatch({
                type: SET_MAX_LOAN_AMOUNT_FOR_MIN_INSTALLMENT,
                payload: shortPeriodHighestOffer.requestedAmount
              })
            }
          }

          //[ZAŁOŻENIE BIZNESOWE] - MECHANIZM PREDEFINIOWANYCH OKRESÓW POŻYCZKI - 
          // W PRZYPADKU GDY NIE UDA SIĘ POBRAĆ OBU OFERT Z PREDEFINIOWANYM OKRESEM
          // ORAZ DOSTANIEMY SPECYFICZNY BŁĄD Z BACKENDU MÓWIĄCY O TYM, ŻE KLIENT JEST POZA LIMITAMI, (NIE POSIADA OPCJI 12 RAT)
          // PRÓBUJEMY WTEDY ZAPREZENTOWAĆ MU DOMYŚLNY WIDOK NA WNIOSKOWANĄ PRZEZ NIEGO ILOŚĆ RAT, JEŚLI TO SIĘ NIE UDA RZUCAMY BŁĘDEM I POAZUJEMY STRONĘ BŁĘDU
          catch(e: any) {
              if(e?.data?.errorCode === PREDEFINED_OFFERS_CUSTOM_ERROR_CODES.OUT_OF_LIMITS_ERROR) {
                await _fetchPredefinedOffersForDefaultFlow(calculateOfferData)

                // WYŁĄCZAMY OPCJĘ PREDEFINIOWANYCH OKRESÓW
                dispatch({
                  type: SET_CURRENT_SELECTED_PREDEFINED_PERIOD,
                  payload: undefined
                })

                dispatch({
                  type: SET_IS_PREDEFINED_PERIODS_AVAILABLE,
                  payload: false
                })

                return
              }

              throw e
          }
        }
      }
      catch (error) {  
        throw error
      }
    }
    //#endregion ===================================================================================================
  


  // =========================== STRONA WYBORU BANKU (AIS) ===========================
  hub.subscribe<BMGateVerificationUrl>(hubMethods.bmVerifyUrl, async (data: IBankVerifyHub) => {
    dispatch({
      type: BANK_VERIFICATION,
      payload: {
        isWaiting: false,
        kontomatikWidgetClient: data.kontomatikWidgetClient,
        kontomatikWidgetOwnerExternalId: data.kontomatikWidgetOwnerExternalId,
      },
    })

    if(isEmpty(data.kontomatikWidgetClient) || isEmpty(data.kontomatikWidgetOwnerExternalId)){
      const ERROR_ANALYTICS_DATA = {
        description: `Dane otrzymane z HUBa przy okazji eventu ${ hubMethods.bmVerifyUrl }.`,
        kontomatikWidgetClient: data.kontomatikWidgetClient,
        kontomatikWidgetOwnerExternalId: data.kontomatikWidgetOwnerExternalId,
      }

      dispatch({ type: SET_APP_HAS_ERROR }) //Ustawiamy globalny błąd aplikacji co spowoduje przejście na ekran z błędem
      await analyticsService.createSingleAnalyticEvent(getAnalyticsEventTypesNames()?.KontomatikWidgetDataFromBackendMissing, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))
      return
    }
    
    
    sessionStorage.remove(STORAGEKEYS.CHANGE_LOADER_TEXT_START_TIME) // CZYŚCIMY KLUCZ TRZYMAJĄCY CZAS DLA CZEKADEŁKA, TAK ABY NA KOLEJNYCH EKRANACH ODLICZANIE ROZPOCZĘŁO SIĘ OD 0
    sessionStorage.changeItemValue(STORAGEKEYS.CURRENT_PAGE_STEP, ApplicationStates.BANK_VERIFICATION.toString()); // Zmieniamy "krok" steppera strony
    
    
    youMoneyService.sendLeadPostback() // YOUMONEY POSTBACK
    youAffService.sendLeadPostback()   // YouAff POSTBACK
    eHelikonService.sendLeadPostback()  // eHelikon POSTBACK
    
    apphistory.push(AppLinks.bmverify)
  })


  // =========================== STRONA DECYZJI NEGATYWNEJ (NG) ===========================
  hub.subscribe(hubMethods.applicationRejected, (data: IRejectedHub) => {
    const sessionStorage = new SessionStorage()
    const isAfterBankVerification = sessionStorage.get(STORAGEKEYS.IS_AFTER_BANK_VERIFICATION)

    if(isAfterBankVerification !== 'true'){ // Jeśli użytkownik dostał decyzję negatywną PRZED ETAPEM WERYFIKACJI W BANKU - wykonujemy POSTBACK, w przeciwnym razie nie
      youMoneyService.sendLeadPostback() // YOUMONEY POSTBACK
      youAffService.sendLeadPostback() // YOUAff POSTBACK
      eHelikonService.sendLeadPostback()  // eHelikon POSTBACK
    }

    apphistory.push(AppLinks.fail)
  })


  // =========================== STRONA WYBORU OFERTY (PP) ===========================
  hub.subscribe(hubMethods.calculateOffer, async (data: IRecalculateOffertHubData) => {
    // [ZAŁOŻENIE BIZNESOWE] - MECHANIZM PREDEFINIOWANYCH OKRESÓW POŻYCZKI
    const { IS_PREDEFINED_PERIODS_AVAILABLE, currentSelectedPredefinedPeriod } = store.getState().applicationState

    // [ZAŁOŻENIE BIZNESOWE] W PRZYPADKU MECHANIZMU PREDEFINIOWANYCH OKRESÓW POŻYCZKI USTAWIAMY OBECNIE WYBRANY PREDEFINIOWANY LIMIT (DOMYŚLNY). 
    // W PRZYPADKU ZWYKŁEGO PROCESU USTAWIAMY MAKS Z OFERTY
    const CURRENT_SELECTED_INSTALLMENT_NUMBER = (IS_PREDEFINED_PERIODS_AVAILABLE === true && currentSelectedPredefinedPeriod !== undefined) ? 
          Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP[currentSelectedPredefinedPeriod] : data.maxInstallmentNumber

      
    if(!data || !data.minInstallmentNumber) {
      const ERROR_ANALYTICS_DATA = {
        id: analyticsService.DISPLAY_ERROR_PAGE_IDS.PREDEFINED_USER_OFFER_NO_OFFER_DATA_FROM_HUB_METHOD,
        reason: `Brak, lub niekompletne dane niezbędne do wyświetlenia oferty, otrzymywanych z metody HUBa ${hubMethods.calculateOffer}.`,
        details: {
          additionalData: {
            description: `Dane otrzymane z metody HUBa ${hubMethods.calculateOffer} z Backendu`,
            data
          }
        },
      }

      dispatch({ type: SET_APP_HAS_ERROR }) //Ustawiamy globalny błąd aplikacji co spowoduje przejście na ekran z błędem
      await analyticsService.createSingleAnalyticEvent(getAnalyticsEventTypesNames()?.FrontendErrorPageDisplayed, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))
    }

    const  minimumLoanAmount = getMinimumLoanAmount(data.minimumLoanAmount) // Zaokrąglamy zawsze w górę do najbliższych 100

    const mapHubResponseToOffert: IOfferState = {
        ...data,
        minimumLoanAmount,

        instalmentAmount: data.instalmentsAmount, //TODO - GDY POPRAWIMY NAZWĘ W BACKENDZIE, MOŻNA USUNĄĆ TĄ LINIJKĘ
        currentSelectedInstallmentNumber: CURRENT_SELECTED_INSTALLMENT_NUMBER,   
        maximumLoanAmount_minimumInstallment: null, //Tymczasowo ustawiamy null, po wejściu na ekran oferty będziemy tą wartość podmieniać
        maximumLoanAmount_maximumInstallment: data.maximumLoanAmount, //Maksymalna kwota pożyczki dla większej ilośći rat
        currentMaximumLoanAmount: data.maximumLoanAmount,
        hasUserChangeAmount: false,
        currentCustomClientOffer: selectCustomClientOfferBasedOnLoanLimits(data.requestedAmount, minimumLoanAmount, data.maximumLoanAmount),
        noOfRecalculation: 1
    }
    

    dispatch({
      type: SET_INITIAL_OFFER,
      payload: mapHubResponseToOffert,
    })


    try {
      if(IS_PREDEFINED_PERIODS_AVAILABLE === true) {
        await fetchAndSavePredefinedOffers(PREDEFINED_OFFERS_FETCH_TYPE.PREDEFINED_PERIODS, mapHubResponseToOffert) 
      }
      else {
        await fetchAndSavePredefinedOffers(PREDEFINED_OFFERS_FETCH_TYPE.DEFAULT, mapHubResponseToOffert) 
      }

      sessionStorage.remove(STORAGEKEYS.CHANGE_LOADER_TEXT_START_TIME) // CZYŚCIMY KLUCZ TRZYMAJĄCY CZAS DLA CZEKADEŁKA, TAK ABY NA KOLEJNYCH EKRANACH ODLICZANIE ROZPOCZĘŁO SIĘ OD 0
      sessionStorage.changeItemValue(STORAGEKEYS.CURRENT_PAGE_STEP, ApplicationStates.CHOOSE_OFFERT.toString()) // Zmieniamy "krok" steppera strony

      dispatch({
        type: CHANGE_APPLICATION_STATE,
        payload: { isWaiting: false },
      })
  
      if (store.getState().offertState.isCustomOfferOnly) {
        apphistory.replace(AppLinks.customOffer)
      } else {
        apphistory.push(AppLinks.offert)
      }
    }
    catch (e: any) {
      console.error("Błąd przy próbie pobrania predefiniowanych ofert z backendu: ", e);

      const ERROR_ANALYTICS_DATA = {
        id: analyticsService.DISPLAY_ERROR_PAGE_IDS.PREDEFINED_USER_OFFER_ERROR_FROM_BACKEND,
        reason: `Błąd przy próbie pobrania predefiniowanych ofert z backendu, po przekierowaniu HUBem na ekran ${AppLinks.offert}.`,
        details: {
           description: e.message,
           errorDataFromBackend: e?.data,
        },
      }

      dispatch({ type: SET_APP_HAS_ERROR }) //Ustawiamy globalny błąd aplikacji co spowoduje przejście na ekran z błędem
      await analyticsService.createSingleAnalyticEvent(getAnalyticsEventTypesNames()?.FrontendErrorPageDisplayed, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))
    }
  })


  // =========================== STRONA PODPISANIA UMOWY (AI) ===========================
  hub.subscribe(hubMethods.documentsRedy, (data: IDocumentsRedyHub) => {
    dispatch({
      type: CHANGE_APPLICATION_STATE,
      payload: {
        isWaiting: false,
      },
    })

    dispatch({
      type: SET_AGREEMENT_FILE_NAME,
      payload: data.fileToDownloadName,
    })

    dispatch({
      type: SET_CONTRACT_DONE_DATA,
      payload: { clientBankAccountNumber: data.clientBankAccountNumber } as IContractDone
    })


    sessionStorage.changeItemValue(STORAGEKEYS.CURRENT_PAGE_STEP, ApplicationStates.SIGN_CONTRACT.toString()) // Zmieniamy "krok" steppera strony
    apphistory.push(AppLinks.contractSigning)
  })

  // =========================== STRONA PODPISANIA UMOWY (AI) ===========================
  hub.subscribe(hubMethods.mobManualVerification, (data: IContractDone) => {
    sessionStorage.add(STORAGEKEYS.IS_MOBYWATEL_MANUAL_VERIFICATION_SUCCEED, 'true')
    _clearMObywatelCache(sessionStorage)

    dispatch({
      type: SET_CONTRACT_DONE_DATA,
      payload: data
    })

    sessionStorage.changeItemValue(STORAGEKEYS.CURRENT_PAGE_STEP, ApplicationStates.FOUNDS_WITHDRAWAL.toString()); // Zmieniamy "krok" steppera strony
    apphistory.push(AppLinks.contractDone);
  })

  
  // =========================== STRONA SESJA WYGASŁA ===========================
  hub.subscribe(hubMethods.sessionTimeout, async () => {
    await analyticsService.createSingleAnalyticEvent(getAnalyticsEventTypesNames()?.FrontendSessionEndPageDisplayed)

    apphistory.push(AppLinks.sessionEnd)
  })
  
  hub.subscribe(hubMethods.clientChoiceIdentification, async(data: IClientChoiceIdentification) => { 
    const getWorkingHoursResponse = await applicationService.getWorkingHours()

    dispatch({
      type: SET_MANUAL_VERIFICATION_HUB_VERIFICATION_STATE,
      payload: {
        manualVerificationPageVerificationState: getWorkingHoursResponse.manualVerificationPageVerificationState,
        workFrom: getWorkingHoursResponse.workFrom
      }
    })

    apphistory.push(AppLinks.clientChoiceManualVerification);
  });


  // ================================= STATUS AE =================================
  hub.subscribe(hubMethods.contractDone, (data: IContractDone) => {
    const sessionStorage = new SessionStorage()
    _clearMObywatelCache(sessionStorage)

    dispatch({
      type: SET_CONTRACT_DONE_DATA,
      payload: data
    })

    sessionStorage.changeItemValue(STORAGEKEYS.CURRENT_PAGE_STEP, ApplicationStates.FOUNDS_WITHDRAWAL.toString()); // Zmieniamy "krok" steppera strony
    apphistory.push(AppLinks.contractDone);
  });  


  // ================================= STATUS AB =================================
  hub.subscribe(hubMethods.preparedForDisbursed, (data: IPreparedForDisbursed) => {
    const sessionStorage = new SessionStorage()
    _clearMObywatelCache(sessionStorage)

    dispatch({
      type: SET_CONTRACT_DONE_DATA,
      payload: data
    })

    sessionStorage.changeItemValue(STORAGEKEYS.CURRENT_PAGE_STEP, ApplicationStates.FOUNDS_WITHDRAWAL.toString()); // Zmieniamy "krok" steppera strony
    apphistory.push(AppLinks.contractDone);
  });  


  hub.subscribe(hubMethods.validationFailedWaitForContact, (data: IValidationFailedWaitForContact) => {
    // apphistory.push(AppLinks.clientPeselReservedPage);
    apphistory.push(AppLinks.manualVerificationclientPeselReservedPage);
  });

  hub.subscribe(hubMethods.validationManualWaitForContact, (data: IValidationManualWaitForContact) => {
    dispatch({
      type: SET_MANUAL_VERIFICATION_HUB_VERIFICATION_STATE,
      payload: {
        manualVerificationPageVerificationState: data.manualVerificationPageVerificationState,
        workFrom: data.workFrom
      }
    })

    apphistory.push(AppLinks.manualVerificationHubRedirection);
  });

  hub.subscribe(hubMethods.mobProcessing, (data: IMobProcessing) => {
    apphistory.push(AppLinks.waiting);
  });
}


export const createAndStartHub = async (dispatch: AppDispatch, source: APP_SOURCE_TYPES): Promise<HubClient | null> => {
  const cookiesStorage = new SessionStorage()
  const sessionState = cookiesStorage.get(STORAGEKEYS.USER_SESSION)

  if(!sessionState){
    return null
  }

  const client = new HttpClient(Environment.apiUrl)

  try {
    const result = (await client.get<ConnectionState>("connection", true)).data

    if (!result.isFinished) {
      const hub = new HubClient("hub")
      subscribeToHub(hub, dispatch, source)

      
      hub.onStatusChange((status) => {
        dispatch({
          type: SET_HUB_CONNECTION_STATUS,
          payload: { status, ...result, userSessionSessionStorageValue: sessionState, error: undefined },
        });
      })


      await hub.start()

      dispatch({ type: HUB_CONNECTED })
      return hub
    }
    else {
      dispatch({
        type: SET_HUB_CONNECTION_STATUS,
        payload: { status: HUB_CONNECTION_STATUS.DISCONNECTED, ...result, userSessionSessionStorageValue: sessionState, error: undefined },
      })
    }
  } 
  catch (e: any) {
    dispatch({
      type: SET_HUB_CONNECTION_STATUS,
      payload: { status: HUB_CONNECTION_STATUS.DISCONNECTED, error: e.message },
    })
  }

  return null
}


export const reconnectOnInvalidConnection = (): ThunkAction<void, AppState, unknown, Action<any>> => async(dispatch, getState) => {
  const state = getState()
  
  if (state.applicationState.isLoading === false && state.applicationState.isAppHasError === false) {
    
    try {
      const client = new HttpClient(Environment.apiUrl)
      const result = (await client.get<ConnectionState>("connection", true)).data
      const storage = new SessionStorage()
      const sessionState = storage.get(STORAGEKEYS.USER_SESSION)
      
      if (!result.isFinished) { 
        if ((!result.isConnected || !result.isValid) && sessionState !== undefined) {
          const hub = new HubClient("hub")
  
          hub.onStatusChange((status) => {
            dispatch({
              type: SET_HUB_CONNECTION_STATUS,
              payload: { status, ...result, userSessionSessionStorageValue: sessionState, error: undefined },
            });
          })
  
          subscribeToHub(hub, dispatch)

          await hub.start()
  
          dispatch({ type: HUB_CONNECTED })
        }
      } 
      else {
        dispatch({
          type: SET_HUB_CONNECTION_STATUS,
          payload: { status: HUB_CONNECTION_STATUS.DISCONNECTED, ...result, userSessionSessionStorageValue: sessionState, error: undefined },
        })
  
        dispatch({ type: HUB_DISCONNECTED })
      }
    }
    catch(e: any) {
      dispatch({
        type: SET_HUB_CONNECTION_STATUS,
        payload: { status: HUB_CONNECTION_STATUS.DISCONNECTED, error: e.message },
      })
    }
  }
}
